import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export function index() {

	var aboutSplide = new Splide('.p-home__about-slide.splide', {
		type: 'loop',
		drag: false,
		gap: 62,
		focus: 'center',
		autoWidth: true,
		arrows: false,
		autoScroll: {
			speed: 1,
			pauseOnHover: false,
		},
		breakpoints: {
			768: {
				gap: 30,
				autoScroll: {
					speed: 0.5,
					pauseOnHover: false,
				},
			}
		}
	});

	aboutSplide.mount({ AutoScroll });



	gsap.utils.toArray('.p-home__business .photo li').forEach((box, index) => {
		const updatebgtl = gsap.timeline({

			scrollTrigger: {
				trigger: box,
				scrub: true,
				start: 'top bottom-=' + index * 50,
				endTrigger: ".p-home__products",
				end: 'center center',
				toggleClass: { targets: box, className: "_active" },
				// toggleActions: 'play none none reset',
				// markers: true,
				scrub: 0.2 // smoothing
			}
		})
		updatebgtl.to(box, {
			// y: 100 * (gsap.utils.toArray('.p-home__business .photo li').length - index + 1),
			y: -100 * ((gsap.utils.toArray('.p-home__business .photo li').length - index + 1) * 0.35)
		});
	})



	const productstl = gsap.timeline({
		scrollTrigger: {
			trigger: ".p-home__products .header",
			scrub: true,
			pin: true,
			start: "top top+=100",
			endTrigger: ".p-home__office .title",
			end: "top bottom",
			pinSpacing: false,
			// markers: true,
		}
	});

	if (document.querySelector('.p-home__mv')) {
		const titles = document.querySelectorAll('.p-home__mv-title .item');
		const logo = document.querySelector('.p-home__mv #logosvg');
		const logobox = document.querySelector('.p-home__mv .box');
		const photos = document.querySelector('.p-home__mv .photos');
		photos.classList.add('type0');
		let count = 0;
		setTimeout(() => {
			logo.classList.add('_start');
			logobox.classList.add('_active');
			titles[count].classList.add('_active');
			photos.classList.add('_active');
			setInterval(() => {
				logo.classList.add('_active');
				photos.classList.add('_end');
				logobox.classList.add('_end');
				titles[count].classList.add('_end');
				// titles[count].classList.remove('_active');
				for (let index = 0; index < titles.length; index++) {
					titles[index].classList.remove('_active');
				}

				setTimeout(() => {
					photos.classList.remove('_end');
					photos.classList.remove('_active');
					logobox.classList.remove('_end');
					logobox.classList.remove('_active');
					photos.classList.remove('type' + count);

					if (titles.length == count + 1) {
						titles[0].classList.add('_active');
						setTimeout(() => {
							photos.classList.add('_active');
							logobox.classList.add('_active');
							photos.classList.add('type0');
						}, 100);
						setTimeout(() => {
							logo.classList.remove('_active');
							titles[count].classList.remove('_end');
							count = 0;
						}, 500);

					} else {
						titles[count + 1].classList.add('_active');
						setTimeout(() => {
							photos.classList.add('_active');
							logobox.classList.add('_active');
							photos.classList.add('type' + (count + 1));
						}, 100);
						setTimeout(() => {
							logo.classList.remove('_active');
							titles[count].classList.remove('_end');
							count++;
						}, 500);

					}

				}, 500);
			}, 7000);
		}, 800);
	}
}
